module.exports = __webpack_public_path__ + "static/media/img-customize.3b54d7ef.png";